/**
 * Данные для фильтра "Тип оцениваемого объекта"
 * */
import { EEstimationTargets } from '../types';
export var estimationTargetSelectorOptions = [{
  value: EEstimationTargets.flat,
  selectedLabel: 'Квартира',
  label: 'Квартира'
}, {
  value: EEstimationTargets.newbuilding,
  selectedLabel: 'ЖК',
  label: 'ЖК'
}];